import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5e4810b8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/prize-breakdown/_prize-breakdown.scss?vue&type=style&index=0&id=5e4810b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4810b8",
  null
  
)

export default component.exports